<div class="procedure-info">
  <div class="subtitle">
    <div class="image-content">
      <img [src]="getPractitionerPhoto()" [alt]="'Foto de ' + (practitioner?.name || 'especialista')" />
    </div>
    <div class="nome">
      {{ practitioner?.name }}
      <small class="instituicao" >{{ healthcareservice?.organization?.name }}</small>

    </div>

     
  </div>

  <div class="row">
    <div class="content">
      <div>
        <span *ngIf="getPractitionerRole()">{{ getPractitionerRole() }}</span>
      </div>
      <div class="service-name">{{ getProcedureDisplayName() }}</div>
      <div class="content-actions">
        <button mat-button color="primary" (click)="openGoogleMapsLocation(); $event.stopPropagation()">
          <mat-icon>location_on</mat-icon>
          <span>Abrir no mapa</span>
        </button>
        <button mat-button color="primary" (click)="openPractitionerInfos(); $event.stopPropagation()">
          <mat-icon>info</mat-icon>
          <span>Sobre o especialista</span>
        </button>
      </div>

      <div class="endereco">{{ getLocation() }}</div>
      <div class="toggle-area">
        <div class="payment-summary">{{ getPaymentSummary() }}</div>

        <button type="button" mat-flat-button color="primary" class="btnVer" id="ver-{{ index }}" (click)="toggleHorarios(index)">
          <mat-icon>keyboard_arrow_down</mat-icon> Ver horários
        </button>
        <button type="button" mat-flat-button color="primary" class="btnFechar" id="fechar-{{ index }}" (click)="toggleHorarios(index)" style="display: none">
          <mat-icon>keyboard_arrow_up</mat-icon> Fechar
        </button>
      </div>    
    </div>
  </div>
</div>
